module.exports = __webpack_public_path__ + "img/pingjia_image_good.1768119790257.png";